const consentManagerPlugin = {
  install: (Vue) => {
    const COOKIE_NAME = 'userConsent'
    const DEFAULT_CONSENT = { necessary: true, preference: '' }

    const getConsent = (key = COOKIE_NAME) => {
      if (typeof window === 'undefined') return DEFAULT_CONSENT
      const consentData = localStorage.getItem(key)
      return consentData ? JSON.parse(consentData) : DEFAULT_CONSENT
    }

    const getConsentValue = (purpose, key = COOKIE_NAME) => {
      if (typeof window === 'undefined') return null
      const consent = getConsent(key)
      return consent ? consent[purpose] : null
    }

    const setConsent = (purpose, value, key = COOKIE_NAME) => {
      if (typeof window === 'undefined') return
      const consent = getConsent(key)
      const updatedConsent = {
        ...consent,
        [purpose]: value,
        timestamp: new Date().toISOString(),
        version: '1.0'
      }
      localStorage.setItem(key, JSON.stringify(updatedConsent))
    }

    const removeConsent = (purpose, key = COOKIE_NAME) => {
      if (typeof window === 'undefined') return
      const consent = getConsent(key)
      if (consent && consent[purpose] !== undefined) {
        const { [purpose]: _, ...rest } = consent
        localStorage.setItem(key, JSON.stringify(rest))
      }
    }

    const clearConsent = (key = COOKIE_NAME) => {
      if (typeof window === 'undefined') return
      localStorage.removeItem(key)
    }

    const hasConsent = (purpose, key = COOKIE_NAME) => {
      if (typeof window === 'undefined') return true
      const consent = getConsent(key)
      return consent && consent[purpose] !== undefined
    }

    // Inject the consent manager functions into the Vue prototype.
    Vue.prototype.$consentManager = {
      getConsent,
      getConsentValue,
      setConsent,
      hasConsent,
      removeConsent,
      clearConsent
    }
  }
}

export default consentManagerPlugin
